import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function CategorySection() {
  return (
    <section className="py-12 md:py-16 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
            赛事分类
          </h2>
          <p className="text-sm text-foreground-500 mt-2">覆盖全球数百项体育赛事，总有一项适合你</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="bg-background-50 border border-background-200/70 rounded-lg p-5 text-center hover:border-primary-300 transition-all cursor-pointer group"
            >
              <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-primary-50 group-hover:bg-primary-100 transition-colors">
                <i className={`${cat.icon} text-xl text-primary-500`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">{cat.name}</h3>
              <p className="text-xs text-foreground-500">{cat.matchCount} 场赛事</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}